<template>
    <div id="container" style="    width: 100%;height:100%;background-color: #f0f2f5; " class="articleDetail">
        <a-spin :spinning="reloadSpinning" :tip="tip" style="    height: 100%;">
            <a-row align="stretch" style="    height: 100%;">
                <a-col :span="articleChatShow?(foldUp?14:24):24" :class="{colUnfoldArticle:!foldUp}"
                    style=" position:relative;padding-right: 2px;background-color: white ">
                    <div style="padding-top: 20px;">
                        <Font id="fontArticle"></Font>
                        <div @scroll="handleScroll" class="scrollView" :style="scrollView">
                            <div class="article-detail">
                                <div
                                    :class="fontSize == 2 ? 'detail' : fontSize == 1 ? 'detail titleSmall' : 'detail titleBig'">
                                    <div
                                        :class="fontSize == 2 ? 'title' : fontSize == 1 ? 'title titleSmall' : 'title titleBig'">
                                        <text selectable="true">{{ article.title }}</text>
                                    </div>
                                    <div class="powerby">
                                        <div
                                            :class="fontSize == 2 ? 'mainText' : fontSize == 1 ? 'mainText titleSmall' : 'mainText titleBig'">
                                            <span>{{ article.updateTime }}</span>
                                            <span class="text">{{ companyDescribe }}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            :class="fontSize == 2 ? 'ai_page' : fontSize == 1 ? 'ai_page abstractSmall' : 'ai_page abstractBig'">
                                            <div
                                                :class="fontSize == 2 ? 'ai_abstract ' : fontSize == 1 ? 'ai_abstract abstractSmall' : 'ai_abstract abstractBig'">

                                                <!-- <div style="display: inline-block;"><img src="../../assets/ai.png" /></div> -->

                                                <div class="abstracti"></div>
                                                <div style="vertical-align: middle;">摘要</div>



                                            </div>
                                            <div>{{article.introduction}}</div>
                                            <div style="color: rgba(0, 0, 0, 0.35);">摘要由情报强企通过智能技术生成</div>
                                            <!-- <hr style="   border-width: 1px medium medium;
    border-style: solid none none;
    border-color: rgb(156 242 245);;margin: 10px 0;"/>
                                            <div>
                                                <div
                                                :class="fontSize == 2 ? 'ai_abstract ' : fontSize == 1 ? 'ai_abstract abstractSmall' : 'ai_abstract abstractBig'">


                                                <div class="abstracti"></div>
                                                <div style="vertical-align: middle;">reason</div>



                                            </div>
                                            <div>企查查开放MCP对接能力+MaxKB给出具体接入教程说明"外部权威企业数据源一Agent工具化"正在标准化落地;对情报产品可用于客户尽调/风控类场景的数据补齐，但本文主要是平台对接操作，未涉及情报生产中的采集/清洗/精选方法增量。</div> -->
                                            <!-- </div> -->
                                        </div>
                                    </div>
                                    <div v-if="article.jsonData && article.jsonData.reason&&article.jsonData.reason.length>0" style=" text-align: justify;padding:0px 20px;line-height: 28px;
  
"><span class="AIreason">推送理由</span><span style="
    margin-left: 10px;
">{{ article.jsonData.reason }}</span></div>

                                    <div class="article-text">
                                        <div v-html="content"></div>
                                    </div>
                                    <template v-if="article.attachmentList && article.attachmentList.length">
                                        <a @click="openDocumentAll(article.attachmentList,article.title )">
                                            <DownloadOutlined /> 全部下载
                                        </a>
                                        <div :class="fontSize == 2 ? 'enclosure' : fontSize == 1 ? 'enclosure titleSmall' : 'enclosure titleBig'"
                                            v-for="(items, indexs) in article.attachmentList" :key="indexs">

                                            <img class="enclosure-image" src="../../assets/article/fujian.png" />
                                            <div>
                                                <a class="enclosure-name"
                                                    @click="openDocument(null, items.attachmentUrl,items.attachmentName,0)">{{
                                                    items.attachmentName }}</a>
                                                <div style="margin-left: auto;">

                                                    <a
                                                        @click="openDocument(null, items.attachmentUrl,items.attachmentName,1)">下载</a>


                                                </div>
                                            </div>
                                        </div>

                                    </template>
                                    <div style="border-top: 2px solid #e9eaec;padding-top: 40px;">
                                        <div style="text-align: center;">这篇文章是您需要的吗？</div>
                                        <div>
                                            <div style="display: flex;padding: 20px 20px 40px;justify-content: center;">
                                                <button style="margin-right: 80px;"
                                                    :class="fontSize == 2 ? 'share-box' : fontSize == 1 ? 'share-box titleSmall' : 'share-box titleBig'"
                                                    type="default" @click="sureRate('like')">
                                                    <img :class="fontSize == 2 ? 'share-image share-1' : fontSize == 1 ? 'share-image share-1 titleSmall' : 'share-image share-1 titleBig'"
                                                        :src="like == false ? require('../../assets/article/like.png') : require('../../assets/article/like_selected.png')"
                                                        mode="widthFix" />
                                                    <text>需要</text>
                                                </button>
                                                <button
                                                    :class="fontSize == 2 ? 'share-box' : fontSize == 1 ? 'share-box titleSmall' : 'share-box titleBig'"
                                                    type="default" @click="sureRate('dislike')">
                                                    <img :class="fontSize == 2 ? 'share-image share-1' : fontSize == 1 ? 'share-image share-1 titleSmall' : 'share-image share-1 titleBig'"
                                                        :src="dislike == false ? require('../../assets/article/dislike.png') : require('../../assets/article/dislike_selected.png')" />
                                                    <text>不需要</text>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="fontSize == 2 ? 'historyList' : fontSize == 1 ? 'historyList titleSmall' : 'historyList titleBig'"
                                        style="margin-bottom: 20rpx;" v-if="historyList && historyList.length > 0">
                                        <div style="    text-align: center; font-weight: bolder;margin: 20px 0px;">
                                            相关推荐</div>
                                        <div style="    padding: 0px 50px;" v-for="(item, index ) in  historyList"
                                            v-bind:key="index">
                                            <div :class="index == historyList.length - 1 ? ' ' : 'split'">
                                                <div class="history-item">
                                                    <div style="width: 120px;height:100px">
                                                        <img style="width: 120px;height:100px"
                                                            :src="item.shareImgUrl == '' ? 'https://enplus.oss-cn-guangzhou.aliyuncs.com/file/13c81b82-285a-473d-bbd1-9b03be0b320c.jpg' : item.shareImgUrl" />
                                                    </div>
                                                    <div style="padding-left:20px">
                                                        <div class="historyListTitle" @click="toTurnArticle(item.id)"
                                                            :class="fontSize == 2 ? 'historyList' : fontSize == 1 ? 'historyList titleSmall' : 'historyList titleBig'"
                                                            style="text-align: justify;">{{ item.title }}</div>
                                                        <!--<view style="color:#a9a1a1;">{{item.updateTime}}</view>-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Share class="article-share" :article="article" :inviteShow="inviteShow"
                                        :content="originalContent" :border="true" />
                                </div>
                                <div v-if="article.translate">
                                    <div class="translateButton" v-if="toTranslateButton == true"
                                        @click="translate(true)" :disabled="translateDisabled">译</div>
                                    <div class="translateButton" v-else @click="translate(false)">原</div>

                                </div>
                                <div v-else-if="companyId == 807">
                                    <div class="translateButton" v-if="toTranslateButton == true"
                                        @click="translate(true, 'en')" :disabled="translateDisabled">EN</div>
                                    <div class="translateButton" v-else @click="translate(false)">CN</div>

                                </div>
                            </div>
                            <Comment ref="commentRef" @closeComment="closeComment" :pagination="pagination"
                                :showVisible="showVisible" :articleId="articleId" :commentData="commentData"
                                @toGetCommentPage="toGetCommentPage" @Changepagination="Changepagination">
                            </Comment>
                        </div>

                        <div class="comment" v-if="commentData">
                            <div>共<span class="num">{{ pagination.total }}</span>条评论</div>
                            <div class="right">
                                <a-button class="toComment" style="border-color: #00B2B9;color: #00b3b9;"
                                    @click="toComment">快来发表你的评论吧~</a-button>
                            </div>
                        </div>

                    </div>
                    <div v-if="articleChatShow">
                        <BackButton right="0px" position="absolute"></BackButton>
                    </div>
                    <a-drawer :get-container="false" class="drawerComment" v-if="openVisible"
                        :style="{ position: 'absolute' }" :width="500" title="" placement="bottom"
                        :visible="openVisible" @close="toClose">
                        <template #extra>
                            <a-button style="margin-right: 8px" @click="toClose">取消</a-button>
                            <a-button type="primary" @click="toAdd" style=" background: #00b2b9;
               border-color: #00b2b9;">发表</a-button>
                        </template>
                        <a-textarea v-model:value="commentValue" placeholder="快来发表你的评论吧~"
                            :auto-size="{ minRows: 5, maxRows: 5 }" />
                    </a-drawer>
                </a-col>
                <!--padding-left: 20px;-->
                <a-col :span="articleChatShow?(foldUp?10:1):0" :class="{colUnfoldChat:!foldUp}"
                    style="background-color: #f0f2f5;">

                    <a-tooltip placement="right">
                        <template #title>
                            <span>{{ foldUp?'收起问答':'展开问答' }}</span>
                        </template>
                        <div class="collapseIcon" @click="toFoldUp">
                            <div><svg-icon name="left-retract" :class="{foldUp:foldUp}" color="#a195e9"
                                    style="margin-right:0px"></svg-icon></div>
                        </div>
                    </a-tooltip>

                    <QiuuPageDetail v-if="showQiuu&&foldUp" :scrollViewHeight="scrollViewHeight" :articleId="articleId">
                    </QiuuPageDetail>



                </a-col>

            </a-row>

        </a-spin>

    </div>

</template>
<script>
import { DownloadOutlined } from '@ant-design/icons-vue';
import { getTreeItem } from '../articleComponent/untils'
import Font from '../articleComponent/Font.vue'
import Comment from '../articleComponent/Comment.vue'
import { openDocument, toDoArticleRecord, openDocumentAll } from './js/index'
import { message } from 'ant-design-vue';
import Share from '../articleComponent/Share'
import { useRouter } from 'vue-router';
import { articleInfor, doMark, turnArticle, getHistoryArticles, getCommentPage, postComment } from '../articleComponent/js/index'
import { onMounted, watch, ref, onUnmounted, reactive, nextTick } from 'vue'
import store from '@/store';
import router from '@/router';
import QiuuPageDetail from '../QiuuComponent/QiuuPageDetail.vue';
import BackButton from '../backButton.vue';
import { showArticleChat } from '@/untils/company';
import { computed } from 'vue';

export default {
    name: 'articleDetail',
    components: { Share, Font, Comment, QiuuPageDetail, BackButton, DownloadOutlined },
    setup() {
        const showBackButton = ref(false)
        const $router = useRouter();
        const foldUp = computed(() => store.getters.foldUp);
        watch(
            () => $router.currentRoute.value,
            (val, old) => {

                if ($router.currentRoute.value.path.indexOf('/articleDetail') > -1 && val && val.query.articleId) {
                    if (old && old && old.path.indexOf('/articleDetail') > -1) {
                        document.querySelector('.scrollView').scrollTop = 0
                    }
                    articleId.value = val.query.articleId
                    toShowDetail()
                }


            })

        watch(() => store.getters.fontSize, (val, oldVal) => {
            fontSize.value = val
            toGetResize(fontSize.value, oldVal, content.value)
        })
        watch(() => showArticleChat(), (val) => {
            articleChatShow.value = showArticleChat()
        })

        const articleChatShow = ref(false)
        onMounted(() => {
            articleChatShow.value = showArticleChat()

            if (articleChatShow.value)
                document.getElementById('backButtom').style.display = 'none'

            companyId.value = store.getters.company.companyId
            if (store.getters.company.companyId == 750 || store.getters.company.companyId == '750')
                companyDescribe.value = '中荣股份'
            if ($router.currentRoute.value.query.articleId) {
                articleId.value = $router.currentRoute.value.query.articleId
                toShowDetail()
            }
            fontSize.value = store.getters.fontSize


        })
        onUnmounted(() => {
            document.getElementById('backButtom').style.display = 'flex'
            toDoArticleRecord(articleId.value, 2)
        })
        const articleId = ref('')
        const scrollViewHeight = ref(0)

        const toShowDetail = () => {

            historyList.value = []
            var height = document.getElementById('container').offsetHeight
            scrollView.value = { height: (height - 120) + 'px', 'overflow-y': 'auto' }
            scrollViewHeight.value = height - 120

            tip.value = ''
            reloadSpinning.value = true
            articleInfor({ id: articleId.value }).then((res) => {

                article.value = res.data
                originalContent.value = res.data.content
                toGetResize(fontSize.value, 2, res.data.content)
                dislike.value = res.data.articleMark == 2 ? true : false
                like.value = res.data.articleMark == 1 ? true : false
                toDoArticleRecord(articleId.value, 0)
                reloadSpinning.value = false
                toGetHistoryArticle(store.getters.company.companyId)
                toGetCommentPage()
                nextTick(() => {
                    showQiuu.value = true
                })
            })
        }
        const pagination = reactive({
            current: 1,
            size: 10,
            total: 0
        })
        const toGetCommentPage = async () => {
            await store.dispatch("clientId").then(() => {
                getCommentPage(
                    {
                        article: articleId.value,
                        company: store.getters.company.companyId,
                        current: pagination.current,
                        size: pagination.size,
                    }
                ).then(async (res) => {
                    pagination.total = res.data.total

                    console.log(store.getters.clientId, 'clientId')
                    for (var i in res.data.records) {
                        res.data.records[i] = getTreeItem(res.data.records[i], true)
                        if (res.data.records[i].replyComments) {
                            for (var j in res.data.records[i].replyComments)
                                res.data.records[i].replyComments[j] = getTreeItem(res.data.records[i].replyComments[j])
                            if (res.data.records[i].replyComments.length > 3) {
                                res.data.records[i]['noShowMoreList'] = res.data.records[i].replyComments.slice(0, 3)
                                res.data.records[i]['showMoreList'] = res.data.records[i]['noShowMoreList']
                            }
                            else {
                                res.data.records[i]['noShowMoreList'] = res.data.records[i].replyComments
                                res.data.records[i]['showMoreList'] = res.data.records[i].replyComments
                            }

                        }

                    }
                    var comment = res.data.records



                    commentData.value = {

                        comment: comment,
                    }

                })


            })
        }
        const commentData = ref()
        const reloadSpinning = ref(false)
        const article = ref('')
        const scrollView = ref('')
        const content = ref('')
        const dislike = ref(false)
        const like = ref(false)
        const toTranslateButton = ref(true)
        const tip = ref('')
        const companyId = ref('')
        const sureRate = (val) => {
            var mark = "0"
            if (val == 'like') {
                like.value = !like.value
                mark = like.value == true ? '1' : '0'
                dislike.value = false
            } else {
                dislike.value = !dislike.value
                mark = dislike.value == true ? '2' : '0'
                like.value = false
            }
            doMark({
                id: articleId.value,
                data: {
                    mark: mark,
                    companyId: store.getters.company.companyId
                }
            }).then(() => {
                message.success(
                    '评价成功！',
                    10,
                );
            })
        }
        const translate = (val, toLang) => {
            if (val == true) {
                translateDisabled.value = true
                tip.value = toLang == 'en' ? 'translating' : "正在翻译中"
                reloadSpinning.value = true
                turnArticle({
                    articleId: articleId.value, toLang: toLang
                }).then(res => {
                    translateContent.value = res.data
                    toGetResize(fontSize.value, 2, translateContent.value)
                    toTranslateButton.value = false
                    reloadSpinning.value = false
                })
            } else {
                toGetResize(fontSize.value, 2, originalContent.value)
                translateDisabled.value = false
                toTranslateButton.value = true
            }
        }
        const translateDisabled = ref(false)
        const translateContent = ref('')
        const originalContent = ref('')
        const fontSize = ref('')
        const toGetResize = (val, oldVal, htmlContent) => {
            if (val == oldVal) {
                content.value = htmlContent;
            }
            htmlContent = htmlContent.replace(/font-size:\d{1,20}px/g, function (param) {
                var result = param.substring(param.indexOf(':') + 1, param.indexOf('p'))
                return 'font-size:' + (Number(result) + (val - oldVal) * 2) + 'px'
            })
            content.value = htmlContent;
        }
        const historyList = ref([])
        const toGetHistoryArticle = (val) => {
            getHistoryArticles({
                articleId: articleId.value,
                companyId: val
            }).then((res) => {
                console.log('xixi', res)
                for (var i in res.data) {
                    if (!res.data[i].shareImgUrl) {
                        if (res.data[i].content) {
                            res.data[i].content.replace(/src=['"]([^'"]+)[^>]*>/i, (match, capture) => {
                                res.data[i].shareImgUrl = capture
                                return match
                            })
                        }

                    }
                    res.data[i].shareImgUrl = !res.data[i].shareImgUrl ? '' : res.data[i].shareImgUrl
                }
                historyList.value = res.data
            })
        }
        const toTurnArticle = (val) => {
            document.querySelector('.scrollView').scrollTop = 0
            router.push({ name: 'articleDetail', query: { articleId: val } })
        }
        const companyDescribe = ref('情报强企')
        const showVisible = ref(true)
        const openVisible = ref(false)
        const toComment = () => {
            openVisible.value = true

        }
        const closeComment = () => {
            showVisible.value = false
        }
        const changePagination = (res) => {
            pagination.total = res
        }
        const commentRef = ref(null)
        const commentValue = ref('')
        const confrimLoading = ref(false)
        const toAdd = () => {


            if (confrimLoading.value == false) {
                confrimLoading.value = true
                postComment({
                    "article": articleId.value,
                    "articleComment": null,
                    "comment": commentValue.value,
                    "company": store.getters.company.companyId
                }).then((res) => {
                    if (res.msg == '处理成功') {

                        message.success('评论成功!')
                        toClose()
                        toGetCommentPage(false)

                    }
                    else message.warning('评论失败！')
                    confrimLoading.value = false
                }).catch(() => {
                    confrimLoading.value = false
                })
            }

        }
        const toClose = () => {

            openVisible.value = false
            commentValue.value = ""
        }
        const showQiuu = ref(false)
        const toFoldUp = () => {
            store.dispatch('foldUp')
        }
        return {
            toFoldUp,
            foldUp,
            articleChatShow,

            scrollViewHeight,
            showQiuu,
            toClose,
            commentValue,
            commentRef,
            toAdd,
            openVisible,
            companyId,
            changePagination,
            toGetCommentPage,
            pagination,
            getCommentPage,
            commentData,
            showVisible,
            toComment,
            closeComment,
            companyDescribe,
            toTurnArticle,
            toGetHistoryArticle,
            historyList,
            toGetResize,
            fontSize,
            originalContent,
            translateContent,
            tip,
            translate,
            toTranslateButton,
            translateDisabled,
            openDocument,
            openDocumentAll,
            sureRate,
            dislike,
            like,
            content,
            scrollView,
            article,
            articleId,
            reloadSpinning
        }
    }
}
</script>
<style lang="less">
.articleDetail {
    padding: 0px !important;
}

.articleDetail {
    .ant-spin-nested-loading {
        height: 100%;
    }

    .ant-spin-container {
        height: 100%;
        overflow-x: hidden;
    }
}
</style>
<style lang="scss" scoped>
.AIreason {
    margin-bottom: 5px;
    display: inline-block;
    background: #d8f2f5;
    padding: 0px 10px;
    color: #19b2b9;
    border-radius: 10px;
    font-weight: 600;
    box-shadow: aqua;
    /* box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px 0px; */
    box-shadow: rgb(0 178 186 / 80%) 0px 1px 3px;
    /* box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px;  */
}

.colUnfoldArticle {
    flex: 1
}

.colUnfoldChat {
    width: 20px;
    flex: none;
}

.collapseIcon {
    width: 20px;
    height: 100%;
    justify-content: center;
    align-items: center;
    position: absolute;
    display: flex;
    z-index: 80;
    cursor: pointer;
}

.foldUp {
    rotate: 180deg;
}

.abstractBig {
    font-size: 16px !important;

    .abstracti {
        width: 16px !important;
        height: 16px !important;
    }
}

.abstractSmall {
    font-size: 12px !important;

    .abstracti {
        width: 12px !important;
        height: 12px !important;
    }

}

.ai_page {

    text-align: justify;
    margin: 20px 20px;
    font-size: 14px;
    line-height: 28px;
    // background-image: linear-gradient(to right,#c9eff2, #dff5f7);
    background-image: url('../../assets/ai-bg.jpg');
    background-size: cover;
    padding: 10px;

    .abstracti {

        width: 15px;
        height: 14px;
        background: url('../../assets/ai.png');
        background-size: 100% 100%;
        margin-right: 5px
    }

    .ai_abstract {
        vertical-align: middle;
        color: #00b2b9;
        justify-content: center;
        align-items: center;
        display: inline-flex;
        font-size: 14px;
        font-weight: bolder;

    }
}

.toComment:hover,
.toComment:focus {
    font-weight: bolder;
}

.comment {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    width: 100%;
    padding: 5px;
    position: absolute;
    bottom: 15px;

    // bottom: 5px;
    .num {
        color: #999;
    }

    .right {
        margin-left: auto;
    }
}

.historyListTitle {
    cursor: pointer;
}

.historyListTitle:hover {
    color: #315efb !important;
}

.historyList {
    font-size: 16px;
}

.historyList.titleSmall {
    font-size: 14px;
}

.historyList.titleBig {
    font-size: 18px;
}

.share-1.titleSmall {
    width: 23px !important
}

.share-1.titleBig {
    width: 27px !important
}

.share-box.titleSmall {
    font-size: 18px !important;
}

.share-box.titleBig {
    font-size: 22px !important;
}

.enclosure-name {
    color: #2c3e50;
    cursor: pointer;
}

.enclosure {
    a:hover {
        color: #315efb !important;
    }
}

.article-text :deep(img) {
    width: 50% !important
}

.scrollView {
    margin: 10px 0px;
    overflow-x: hidden;
    overflow-y: auto;
}

.history-item {
    display: flex;
    align-items: center;
    padding: 15px 10px;
}

.split {
    border-bottom: 1px solid #e4e7ed
}

.detail.titleBig {
    font-size: 16px !important;
}

.detail.titleSmall {
    font-size: 12px !important;
}

.share-box.titleBig {
    font-size: 26px;
}

.share-box.titleSmall {
    font-size: 26px;
}

.share-box {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    background-color: transparent;
    border: 0;
    font-size: 20px;
    color: #2b2b2b;
    justify-content: center;

    &::after {
        border: 0;
    }

    &.min-share-btn {
        min-width: 140px;
    }

    .share-image {
        width: 25px;
        height: auto;
        margin-right: 8px;

        &.share-1 {
            width: 25px;
        }
    }
}

.article-detail {
    .detail {
        padding: 20px 20px 80px;
        font-size: 14px;
        padding-bottom: 0px;


        .title {
            text-align: left;
            font-weight: bold;
            font-size: 18px;
            padding: 0px 20px;
        }

        .title.titleSmall {
            font-size: 16px;
        }

        .title.titleBig {
            font-size: 20px;
        }

        .powerby {
            margin-top: 20px;

            .mainText.titleSmall {
                font-size: 12px;
            }

            .mainText.titleBig {
                font-size: 16px;
            }

            .mainText {
                background-color: #F3F4FC;
                color: rgba(0, 0, 0, 0.35);
                font-size: 14px;
                text-align: left;
                margin: 0px 20px;

                line-height: 28px;

                .text {
                    padding-left: 30px;
                }
            }
        }

        .article-text {
            word-break: break-all;
        }

        .enclosure.titleBig {
            padding: 7px 12px;
            font-size: 16px;

            .enclosure-image {
                width: 32px;
                height: 32px;
                margin-right: 10px;
            }
        }

        .enclosure.titleSmall {
            padding: 3px 7px;
            font-size: 12px;

            .enclosure-image {
                width: 28px;
                height: 28px;
                margin-right: 10px;
            }
        }

        .enclosure {
            display: flex;
            align-items: center;
            margin-top: 5px;
            padding: 5px 10px;
            border: 2px solid #f3f3f5;
            border-radius: 8px;
            font-size: 14px;

            .enclosure-image {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }

        .article-share {
            margin-top: 40px;
        }
    }



    .home {
        margin-left: 24px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .home-img {
            width: 48px;
            height: 48px;
        }
    }
}

.translateButton {
    cursor: pointer;
    font-size: 18px;
    bottom: 60px;
    right: 20px;
    border-radius: 50%;
    z-index: 900;
    opacity: 1;
    width: 40px;
    height: 40px;
    position: absolute;
    /* z-index: 9; */
    display: flex;
    flex-direction: row;
    flex-direction: column;
    justify-content: center;
    background-color: #009DA6;
    color: #ffffff;
    align-items: center;
    transition: opacity 0.4s;
    text-align: center;
}
</style>
<style lang="scss">
.drawerComment {
    .ant-drawer-content-wrapper {
        height: auto !important;
    }
}
</style>
